(function () {
  'use strict';

  /* Les blocs apparaissent quand ils entrent dans l'ecran. */
  function reveler() {
    var cibles = document.querySelectorAll('.ch-up:not(.est-la)');
    if (!cibles.length) return;
    if (!('IntersectionObserver' in window)) {
      Array.prototype.forEach.call(cibles, function (e) { e.classList.add('est-la'); });
      return;
    }
    var obs = new IntersectionObserver(function (entrees) {
      entrees.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('est-la'); obs.unobserve(e.target); }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.06 });
    Array.prototype.forEach.call(cibles, function (e) { obs.observe(e); });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', reveler);
  } else { reveler(); }
  document.addEventListener('shopify:section:load', reveler);
})();

/* =====================================================================
   LE COMPTEUR DU PANIER
   Le theme ne rafraichit que sa propre pastille « .cart-count-badge ».
   Notre en-tete a la sienne : sans ca, elle restait figee tant qu'on
   ne rechargeait pas la page.
   ===================================================================== */
window.chMajPanier = function () {
  return fetch('/cart.js')
    .then(function (r) { return r.json(); })
    .then(function (panier) {
      document.querySelectorAll('.ch-tete__compte').forEach(function (e) {
        e.textContent = panier.item_count;
      });
      return panier;
    })
    .catch(function () { return null; });
};
